var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "schedule-wrapper" }, [
    _c(
      "div",
      { staticClass: "schedule__pop__block" },
      _vm._l(_vm.schedules, function (schedule, index) {
        return _c("ScheduleRow", {
          key: "schedule_" + index,
          attrs: { schedule: schedule },
          on: {
            goToDetails: function ($event) {
              return _vm.goToDetailsHandler(schedule)
            },
          },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }